module.exports = __webpack_public_path__ + "img/image1.d8e269d7.jpg";